<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex flex-column flex-md-row justify-content-between mb-3 gap-3">
      <div class="align-self-start oder-md-1 order-2 d-flex gap-2">
        <BButton
          size="sm"
          variant="primary"
          @click.prevent="() => $refs.multipleCreate.openMultiple()"
        >
          Assign Memo
        </BButton>
      </div>
      <div class="order-md-2 order-1">
        <BBreadcrumb
          v-if="$route.meta.breadcrumb"
          :items="$route.meta.breadcrumb || []"
        />
      </div>
    </div>

    <BNav
      class="scrollable-x-tabs no-scrollbar nav-customer-memos-tabs"
      pills
    >
      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>

      <BNavItem
        :active="getActiveRoute('pending')"
        :to="{
          name: 'asm.tracking.customer-memos.pending'
        }"
      >
        <i :class="iconState('fa-file-circle-question', getActiveRoute('pending'))" /> Pending
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('processing')"
        :to="{
          name: 'asm.tracking.customer-memos.processing'
        }"
      >
        <i :class="iconState('fa-file-signature', getActiveRoute('processing'))" /> Processing
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('history')"
        :to="{
          name: 'asm.tracking.customer-memos.history'
        }"
      >
        <i :class="iconState('fa-clock-rotate-left', getActiveRoute('history'))" /> History
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('summaries')"
        :to="{
          name: 'asm.tracking.customer-memos.summaries'
        }"
      >
        <i :class="iconState('fa-file-chart-column', getActiveRoute('summaries'))" /> Summaries
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('documents')"
        :to="{
          name: 'asm.tracking.customer-memos.documents'
        }"
      >
        <i :class="iconState('fa-file-pdf', getActiveRoute('documents'))" /> Documents
      </BNavItem>

      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="right: 20px; padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>
    </BNav>

    <RouterView
      ref="tableView"
      @edit:row="memo => $refs.memoCrud.editMemo(memo)"
      @verify:row="memo => $refs.memoVerification.verifyMemo(memo)"
      @view:row="memo => $refs.memoVerification.viewMemo(memo)"
    />

    <MemoCrud
      ref="memoCrud"
      @update:rows="() => $refs.tableView.api.refetch()"
      @update:row="memo => $refs.tableView.api.updateRow(memo)"
    />

    <MemoVerification
      ref="memoVerification"
      @update:rows="() => $refs.tableView.api.refetch()"
      @update:row="memo => $refs.tableView.api.updateRow(memo)"
    />

    <MultipleCreate
      ref="multipleCreate"
      @update:rows="() => $refs.tableView.api.refetch()"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MultipleCreate from '@/views/asm/customer-memos/components/MultipleCreate.vue'
import MemoCrud from './components/MemoCrud.vue'
import MemoVerification from './components/MemoVerification.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'ASMCustomerMemosBase',

  components: {
    MultipleCreate,
    MemoCrud,
    MemoVerification
  },

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth',
    'asm'
  ],

  metaInfo: () => ({
    title: 'ASM - Customer Memos'
  }),

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-customer-memos-tabs')
      })
    }
  },

  beforeDestroy () {
    this.detachArrowScroller('.nav-customer-memos-tabs')
  },

  methods: {
    getTabRoute (tabName) {
      return `/asm/tracking/customer-memos/${tabName}`
    },

    getActiveRoute (tabName) {
      return this.$route.path === this.getTabRoute(tabName)
    }
  }
}
</script>
